import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';

import './SellerInfo.styles.scss';
import './SellerInfo.styles.responsive.scss';

type SellerInfoProps = {
  className?: string;
  title: string;
  imageUrl: string;
  leadWithdrawnInterest: boolean;
};

const SellerInfo: React.FC<SellerInfoProps> = (props) => {
  const { className, leadWithdrawnInterest, title, imageUrl } = props;

  const { t } = useTranslation();

  const classes = classNames('seller-info', className);

  return (
    <div className={classes}>
      <div className="seller-info__title">
        <span>{t('nowChattingWith')}</span>
        <p>{title || t('companyNameMissing')}</p>
        <span>{t('noteMessagingWithMultiplePeople')}</span>
        {leadWithdrawnInterest && (
          <p className="withdrawn-tag">{t('withdrawn')}</p>
        )}
      </div>

      {!!imageUrl && <ResolveImage src={imageUrl} asCompanyLogo />}
    </div>
  );
};

export default SellerInfo;
